import { Box, CircularProgress } from "@mui/material";
import { useContext, useEffect } from "react";
import { Context } from "../context/Context";
import { useOktaAuth } from "@okta/okta-react";
import { cookieEraser } from "../helpers/cookieEraser";

const classes = {
    loadingPage: {
        width: "100%",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
    },
};

export default function Cancel() {
    const { cancelRedirectUrl, setIsLogoutInProgress } = useContext(Context);
    const { oktaAuth } = useOktaAuth();

    useEffect(() => {
        handleExternalLogout(cancelRedirectUrl);
    }, []);

    const handleExternalLogout = async (
        cancelUrl = process.env.REACT_APP_BASE_URL
    ) => {
        setIsLogoutInProgress(true);
        try {
            await oktaAuth.revokeAccessToken();
            oktaAuth.session
                .close()
                .then(() => {
                    sessionStorage.clear();
                    cookieEraser();
                    window.location.assign(cancelUrl);
                    return;
                })
                .catch((e) => {
                    return (window.location.href =
                        process.env.REACT_APP_BASE_URL);
                });
        } catch (error) {
            console.error("Logout failed:", error);
            return (window.location.href = process.env.REACT_APP_BASE_URL);
        }
    };

    return (
        <Box sx={classes.loadingPage}>
            <CircularProgress />
        </Box>
    );
}
